/* RBC Wishlist (V11)
   Saved items, stored per customer when signed in, per browser when not.
   Self-contained: document-level delegation so it survives section re-renders. */
(function () {
  'use strict';

  var GUEST_KEY = 'rbc_wish';
  var custId = (window.RBC_CUSTOMER_ID || '').toString();
  var KEY = custId ? 'rbc_wish_' + custId : GUEST_KEY;

  function read(k) {
    try { var v = JSON.parse(localStorage.getItem(k) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  /* Signing in adopts anything saved as a guest, then clears the guest list. */
  if (custId) {
    var guest = read(GUEST_KEY);
    if (guest.length) {
      var merged = read(KEY);
      for (var i = 0; i < guest.length; i++) {
        if (merged.indexOf(guest[i]) === -1) merged.push(guest[i]);
      }
      write(merged);
      try { localStorage.removeItem(GUEST_KEY); } catch (e) {}
    }
  }

  function items() { return read(KEY); }
  function has(handle) { return items().indexOf(handle) !== -1; }

  function toggle(handle) {
    var list = items();
    var at = list.indexOf(handle);
    if (at === -1) { list.push(handle); } else { list.splice(at, 1); }
    write(list);
    sync();
    document.dispatchEvent(new CustomEvent('rbc:wishlist', { detail: { handle: handle, saved: at === -1, count: list.length } }));
    return at === -1;
  }

  function remove(handle) {
    var list = items();
    var at = list.indexOf(handle);
    if (at === -1) return;
    list.splice(at, 1);
    write(list);
    sync();
    document.dispatchEvent(new CustomEvent('rbc:wishlist', { detail: { handle: handle, saved: false, count: list.length } }));
  }

  /* Paint every heart on the page + the header count. */
  function sync() {
    var list = items();
    var buttons = document.querySelectorAll('[data-wish]');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var on = list.indexOf(b.getAttribute('data-wish')) !== -1;
      b.classList.toggle('is-saved', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = on ? 'Remove from saved items' : 'Save this piece';
      b.setAttribute('aria-label', label);
      b.setAttribute('title', label);
      var t = b.querySelector('[data-wish-text]');
      if (t) t.textContent = on ? 'Saved' : 'Save';
    }
    var counters = document.querySelectorAll('[data-wish-count]');
    for (var j = 0; j < counters.length; j++) {
      counters[j].textContent = list.length;
      if (list.length) { counters[j].removeAttribute('hidden'); }
      else { counters[j].setAttribute('hidden', ''); }
    }
  }

  /* Delegated so cards rendered later still work. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wish]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-wish');
    if (!handle) return;
    var nowSaved = toggle(handle);
    btn.classList.remove('is-pop');
    void btn.offsetWidth;
    if (nowSaved) btn.classList.add('is-pop');
  }, true);

  /* Another tab changed the list. */
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });

  /* ---------- Saved items page ---------- */

  function money(cents) {
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '₦' + n;
  }

  function card(p) {
    var img = p.featured_image ? p.featured_image : (p.images && p.images[0]);
    var media = img
      ? '<img class="media__img" src="' + img + '&width=700" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="700" height="875">'
      : '<span class="media__tag media__tag--soft">rbc</span>';
    var price = p.compare_at_price && p.compare_at_price > p.price
      ? '<span class="price__sale">' + money(p.price) + '</span> <s class="price__compare">' + money(p.compare_at_price) + '</s>'
      : money(p.price);
    var sold = p.available === false
      ? '<span class="product-badge product-badge--muted">Currently unavailable</span>' : '';
    return '' +
      '<article class="product-card wish-card' + (p.available === false ? ' is-soldout' : '') + '" data-wish-card="' + p.handle + '">' +
        '<div class="product-card__media">' +
          '<a class="product-card__media-link" href="/products/' + p.handle + '" tabindex="-1" aria-hidden="true">' +
            '<div class="product-card__media-scale"><div class="media media--portrait media--studio">' + media + '</div></div>' +
          '</a>' + sold +
          '<button class="wish-btn is-saved" type="button" data-wish="' + p.handle + '" aria-pressed="true" aria-label="Remove from saved items">' +
            '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12 21C12 21 3.5 15.4 3.5 9.5 3.5 6.9 5.6 4.8 8.2 4.8c1.6 0 3 .8 3.8 2 .8-1.2 2.2-2 3.8-2 2.6 0 4.7 2.1 4.7 4.7C20.5 15.4 12 21 12 21Z"/></svg>' +
          '</button>' +
        '</div>' +
        '<a class="product-card__name-link" href="/products/' + p.handle + '"><h3 class="product-card__name">' + p.title + '</h3></a>' +
        '<p class="product-card__price">' + price + '</p>' +
      '</article>';
  }

  function renderPage() {
    var grid = document.getElementById('wishGrid');
    if (!grid) return;
    var empty = document.getElementById('wishEmpty');
    var count = document.getElementById('wishPageCount');
    var list = items();

    if (count) {
      count.textContent = list.length === 1 ? '1 piece saved' : list.length + ' pieces saved';
    }
    if (!list.length) {
      grid.innerHTML = '';
      grid.setAttribute('hidden', '');
      if (empty) empty.removeAttribute('hidden');
      return;
    }
    if (empty) empty.setAttribute('hidden', '');
    grid.removeAttribute('hidden');

    Promise.all(list.map(function (h) {
      return fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var live = [];
      var goodHandles = [];
      products.forEach(function (p, i) {
        if (p) { live.push(p); goodHandles.push(list[i]); }
      });
      /* Drop handles that no longer exist in the store. */
      if (goodHandles.length !== list.length) write(goodHandles);
      grid.innerHTML = live.map(card).join('');
      if (count) {
        count.textContent = live.length === 1 ? '1 piece saved' : live.length + ' pieces saved';
      }
      if (!live.length) {
        grid.setAttribute('hidden', '');
        if (empty) empty.removeAttribute('hidden');
      }
      sync();
    });
  }

  /* Removing from the saved-items page pulls the card out in place. */
  document.addEventListener('rbc:wishlist', function (e) {
    var grid = document.getElementById('wishGrid');
    if (!grid || e.detail.saved) return;
    var card = grid.querySelector('[data-wish-card="' + e.detail.handle + '"]');
    if (card) {
      card.classList.add('is-leaving');
      setTimeout(function () {
        card.remove();
        var left = grid.querySelectorAll('[data-wish-card]').length;
        var count = document.getElementById('wishPageCount');
        if (count) count.textContent = left === 1 ? '1 piece saved' : left + ' pieces saved';
        if (!left) {
          grid.setAttribute('hidden', '');
          var empty = document.getElementById('wishEmpty');
          if (empty) empty.removeAttribute('hidden');
        }
      }, 220);
    }
  });

  /* ---------- Saved items drawer ---------- */

  function drawerRow(p) {
    var img = p.featured_image ? p.featured_image : (p.images && p.images[0]);
    var media = img
      ? '<img src="' + img + '&width=200" alt="" loading="lazy" width="80" height="100">'
      : '<span class="media__tag media__tag--soft">rbc</span>';
    var price = p.compare_at_price && p.compare_at_price > p.price
      ? '<span class="price__sale">' + money(p.price) + '</span> <s class="price__compare">' + money(p.compare_at_price) + '</s>'
      : money(p.price);
    var action = p.available
      ? '<button class="wish-row__add" type="button" data-wish-add="' + (p.variants[0] && p.variants[0].id) + '">Add to bag</button>'
      : '<span class="wish-row__out">Currently unavailable</span>';
    return '' +
      '<div class="wish-row" data-wish-row="' + p.handle + '">' +
        '<a class="wish-row__media" href="/products/' + p.handle + '">' + media + '</a>' +
        '<div class="wish-row__info">' +
          '<a class="wish-row__name" href="/products/' + p.handle + '">' + p.title + '</a>' +
          '<p class="wish-row__price">' + price + '</p>' + action +
        '</div>' +
        '<button class="wish-row__remove" type="button" data-wish="' + p.handle + '" aria-label="Remove ' + p.title.replace(/"/g, '&quot;') + '">' +
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">' +
          '<path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13"/></svg>' +
        '</button>' +
      '</div>';
  }

  function renderDrawer() {
    var body = document.getElementById('wishDrawerBody');
    if (!body) return;
    var foot = document.getElementById('wishDrawerFoot');
    var list = items();

    if (!list.length) {
      body.innerHTML =
        '<div class="cart-empty">' +
          '<h3 class="cart-empty__title">Nothing saved yet</h3>' +
          '<p class="cart-empty__text">Tap the heart on any piece and it will wait for you here.</p>' +
          '<a class="btn btn--primary" href="/collections/all">Start browsing</a>' +
        '</div>';
      if (foot) foot.setAttribute('hidden', '');
      return;
    }
    body.innerHTML = '<p class="wish-drawer__loading">Loading your saved pieces</p>';
    Promise.all(list.map(function (h) {
      return fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var live = [], good = [];
      products.forEach(function (p, i) { if (p) { live.push(p); good.push(list[i]); } });
      if (good.length !== list.length) write(good);
      if (!live.length) { renderDrawer(); return; }
      body.innerHTML = live.map(drawerRow).join('');
      if (foot) foot.removeAttribute('hidden');
      sync();
    });
  }

  function openDrawer() {
    var d = document.getElementById('wishDrawer');
    var bd = document.getElementById('wishBackdrop');
    if (!d) return;
    renderDrawer();
    if (bd) { bd.removeAttribute('hidden'); requestAnimationFrame(function () { bd.classList.add('is-open'); }); }
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var close = document.getElementById('wishClose');
    if (close) close.focus();
  }

  function closeDrawer() {
    var d = document.getElementById('wishDrawer');
    var bd = document.getElementById('wishBackdrop');
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (bd) {
      bd.classList.remove('is-open');
      setTimeout(function () { bd.setAttribute('hidden', ''); }, 300);
    }
    document.body.classList.remove('is-locked');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest && t.closest('#wishHeaderLink, #wishNavLink, #wishAccountLink')) {
      e.preventDefault();
      /* Close the mobile menu first if it is open. */
      var nav = document.querySelector('.mobile-nav.is-open');
      if (nav) {
        nav.classList.remove('is-open');
        var nb = document.querySelector('.nav-backdrop');
        if (nb) nb.classList.remove('is-open');
      }
      openDrawer();
      return;
    }
    if (t.closest && t.closest('#wishClose, #wishBackdrop')) { e.preventDefault(); closeDrawer(); return; }

    var add = t.closest ? t.closest('[data-wish-add]') : null;
    if (add) {
      e.preventDefault();
      var id = add.getAttribute('data-wish-add');
      add.disabled = true;
      add.textContent = 'Adding';
      var fd = new FormData();
      fd.append('id', id);
      fd.append('quantity', '1');
      var done = function () {
        add.textContent = 'Added';
        setTimeout(function () { add.textContent = 'Add to bag'; add.disabled = false; }, 1600);
      };
      if (window.RBC_CART && window.RBC_CART.addItem) {
        /* Reuses the cart module so the drawer HTML and badge stay in step. */
        window.RBC_CART.addItem(fd).then(done).catch(function () {
          add.textContent = 'Add to bag'; add.disabled = false;
        });
      } else {
        fetch('/cart/add.js', { method: 'POST', body: fd })
          .then(function (r) { return r.json(); })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            document.querySelectorAll('.cart-count').forEach(function (b) {
              b.textContent = cart.item_count;
              if (cart.item_count) { b.removeAttribute('hidden'); } else { b.setAttribute('hidden', ''); }
            });
            done();
          })
          .catch(function () { add.textContent = 'Add to bag'; add.disabled = false; });
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = document.getElementById('wishDrawer');
      if (d && d.classList.contains('is-open')) closeDrawer();
    }
  });

  /* Removing inside the drawer pulls the row out in place. */
  document.addEventListener('rbc:wishlist', function (e) {
    var body = document.getElementById('wishDrawerBody');
    if (!body || e.detail.saved) return;
    var row = body.querySelector('[data-wish-row="' + e.detail.handle + '"]');
    if (row) {
      row.classList.add('is-leaving');
      setTimeout(function () {
        row.remove();
        if (!body.querySelectorAll('[data-wish-row]').length) renderDrawer();
      }, 220);
    }
  });

  function init() { sync(); renderPage(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.RBCWishlist = { items: items, has: has, toggle: toggle, remove: remove, sync: sync };
})();
